import posthog from 'posthog-js';

const normal_condition = posthog.isFeatureEnabled('is-modec') ? 'Normal Condition' : 'Low';
const alarm_condition = posthog.isFeatureEnabled('is-modec') ? 'Alarm Condition' : 'Medium';
const critical_condition = posthog.isFeatureEnabled('is-modec')
  ? 'Critical Condition'
  : 'Very High';
const potential_problem = posthog.isFeatureEnabled('is-modec') ? 'Potential Problem' : 'High';

export const i18nRecordsPage = {
  title: 'Records',
  add_a_comment: 'Add a comment',
  view_records: 'View records',
  event_records: 'Event records',
  attachments: 'Attachments',
  comments: 'Comments',
  summary: {
    attachments: 'Attachments',
    comments: 'Comments',
    last_update: 'Last update: ',
  },

  category: {
    generic: {
      comment: 'Comment',
      attached_file: 'Attached file',
      detached_file: 'Detached file',
      updated: 'Updated',
    },
    Case: {
      status_updated: 'Updated',
      severity_updated: 'Updated',
      created: 'Created',
      owner_updated: 'Owner updated',
      action_created: 'Created',
      action_updated: 'Updated',
      action_deleted: 'Deleted',
    },
    Alarm: {
      useful: 'Classification: Useful',
      not_useful: 'Classification: Not useful',
      reclassify_useful: 'Reclassification: Useful',
      reclassify_not_useful: 'Reclassification: Not useful',
    },

    ConditionDeviation: {
      action_status_updated: 'Action status updated',
      severity_updated: 'Severity updated',
      created: 'Created',
      updated: 'Updated',
    },
  },

  category_message: {
    generic: {
      attached_file: '@{{user_name}} attached {{field}}',
      detached_file: '@{{user_name}} detached {{field}}',
      updated: '@{{user_name}} changed: {{field}}',
    },
    Case: {
      status_updated: '@{{user_name}} changed stage to "{{field}}"',
      severity_updated: '@{{user_name}} changed severity to: {{field}}',
      created: '@{{user_name}} created Case with Severity {{field}}',
      owner_updated: '@{{field}} is the new owner of the case',
      action_created: '@{{user_name}} created Action {{field}}',
      action_updated: '@{{user_name}} changed {{field}} of "{{name}}"',
      action_deleted: '@{{user_name}} deleted Action {{field}}',
    },
    Alarm: {
      useful: '@{{user_name}} acknowledged this alarm as Useful, {{field}}',
      not_useful: '@{{user_name}} acknowledged this alarm as Not useful, {{field}}',
      reclassify_useful: '@{{user_name}} reclassified this alarm as Useful, {{field}}',
      reclassify_not_useful: '@{{user_name}} reclassified this alarm as Not useful, {{field}}',
    },

    ConditionDeviation: {
      action_status_updated: '@{{user_name}} changed Action Status to {{field}}',
      severity_updated: '@{{user_name}} changed Severity to {{field}}',
      created:
        '@{{user_name}} created a condition deviation with the following status and severity, respectively: {{field}}',
    },
  },

  values: {
    // classification
    useful: 'Useful',
    not_useful: 'Not useful',

    // action_status
    investigating: 'Investigating',
    action_issued: 'Action issued',
    canceled: 'Canceled',
    under_evaluation: 'Under evaluation',
    completed: 'Completed',

    normal_condition,
    alarm_condition,
    critical_condition,
    potential_problem,
    not_monitored: 'Not Monitored',
    not_operated: 'Not Operated',

    // severity
    very_high: 'Very High',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    information: 'Low',
    warning: 'Low',
    minor: 'Medium',
    major: 'High',
    critical: 'Very High',
  },
};
